// Utility for managing subscription refresh events globally
class SubscriptionRefreshManager {
  constructor() {
    this.listeners = new Set();
  }

  // Subscribe to subscription refresh events
  subscribe(listener) {
    this.listeners.add(listener);
    
    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener);
    };
  }

  // Trigger subscription refresh for all listeners
  refresh() {
    this.listeners.forEach(listener => {
      if (typeof listener === 'function') {
        listener();
      }
    });
  }

  // Get the singleton instance
  static getInstance() {
    if (!SubscriptionRefreshManager.instance) {
      SubscriptionRefreshManager.instance = new SubscriptionRefreshManager();
    }
    return SubscriptionRefreshManager.instance;
  }
}

// Export singleton instance
export const subscriptionRefreshManager = SubscriptionRefreshManager.getInstance();

// Helper function to trigger subscription refresh
export const triggerSubscriptionRefresh = () => {
  subscriptionRefreshManager.refresh();
};
